import moment from 'moment';
import { createActions } from 'redux-actions';

import { ENDPOINTS_EVENTS } from '../../config';
import { defaultErrorMessage, globalFetch, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const { dashboardEventsResponse, dashboardEventsRequest, dashboardEventsResponseFailure } = createActions(
  {
    DASHBOARD_EVENTS_RESPONSE: data => ({ data }),
  },
  'DASHBOARD_EVENTS_REQUEST',
  'DASHBOARD_EVENTS_RESPONSE_FAILURE'
);

export function getLastEvents() {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();

    if (state.getIn(['dashboard', 'events', 'isfetching']) === true) {
      return dispatch(dashboardEventsRequest());
    }
    dispatch(dashboardEventsRequest());

    const today = moment.tz('UTC').format('YYYY-MM-DDTHH:mm:ssZ');

    return globalFetch(
      `${ENDPOINTS_EVENTS.events}?limit=100&order=start&start>=${window.encodeURIComponent(today)}`,
      {
        method: 'GET',
        credentials: 'include',
      },
      dispatch,
      () => dispatch(dashboardEventsResponseFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'DASHBOARD_EVENTS_RESPONSE_FAILURE')) {
          return json;
        } else {
          return dispatch(dashboardEventsResponse(json));
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(dashboardEventsResponseFailure());
      });
  };
}
